var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6673 17.3867V18.0001C24.6665 19.4377 24.201 20.8365 23.3402 21.988C22.4794 23.1394 21.2695 23.9817 19.8909 24.3893C18.5123 24.797 17.0388 24.748 15.6903 24.2498C14.3418 23.7516 13.1904 22.8308 12.408 21.6248C11.6255 20.4188 11.2538 18.9921 11.3484 17.5576C11.443 16.1231 11.9988 14.7576 12.9328 13.6648C13.8669 12.572 15.1292 11.8103 16.5314 11.4935C17.9337 11.1767 19.4008 11.3216 20.714 11.9067M24.6673 12.6667L18.0007 19.3401L16.0007 17.3401",
    stroke: "#039855",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#ECFDF3",
    strokeWidth: 4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTick);
export default "data:image/svg+xml,%3csvg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='2' y='2' width='32' height='32' rx='16' fill='%23D1FADF'/%3e %3cpath d='M24.6673 17.3867V18.0001C24.6665 19.4377 24.201 20.8365 23.3402 21.988C22.4794 23.1394 21.2695 23.9817 19.8909 24.3893C18.5123 24.797 17.0388 24.748 15.6903 24.2498C14.3418 23.7516 13.1904 22.8308 12.408 21.6248C11.6255 20.4188 11.2538 18.9921 11.3484 17.5576C11.443 16.1231 11.9988 14.7576 12.9328 13.6648C13.8669 12.572 15.1292 11.8103 16.5314 11.4935C17.9337 11.1767 19.4008 11.3216 20.714 11.9067M24.6673 12.6667L18.0007 19.3401L16.0007 17.3401' stroke='%23039855' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round'/%3e %3crect x='2' y='2' width='32' height='32' rx='16' stroke='%23ECFDF3' stroke-width='4'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };